<template>
    <div class="wrap" @touchend.stop="$emit('remove')">
        <div class="content">
            <div class="load">

            </div>
            <br>
            <div>
                正在请求数据
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loading',
    props:{
        alertpop_text: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
}

.content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 10rem;
    width: 11rem;
    margin: auto;
    text-align: center;
    padding-top: 1rem;
    border-radius: 0.3rem;
    background: rgba(0, 0, 0, 0.4)
}

.content div {
    display: inline-block;
}

.load {
    height: 5rem;
    width: 5rem;
    background: url(../assets/images/loading.png)no-repeat center;
    margin-bottom: 2rem;
    animation-name: rotate;
    animation-duration: 2s;
    animation-iteration-count:infinite;
    -webkit-animation-name: rotate;
    -webkit-animation-duration: 2s;
    -webkit-animation-iteration-count:infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
